<template>
    <div>
        <h1>Neues Passwort festlegen</h1>
        <div id="enterdata">
            <div style="padding-bottom:20px">
                Bitte gib unten dein neues, gewünschtes Passwort ein.<br/> Sobald du es gespeichert hast, musst du dich neu einloggen.
            </div>
            <div style="margin:10px 0 20px 0;max-width:320px">
                <div class="fontColor3 font0875" v-if="hash==null">Altes Passwort</div>
                <input type="password" id="oldPassword" v-if="hash==null" v-model="oldPassword" />

                <div class="fontColor3 font0875" style="margin-top:20px">Neues Passwort</div>
                <input type="password" id="newPassword1" v-model="newPassword1" />

                <div class="fontColor3 font0875" style="margin-top:20px">Passwort wiederholen</div>
                <input type="password" id="newPassword2" v-model="newPassword2" />

                <div style="margin-top:20px">
                    <button v-on:click="changePassword" class="btn btn-primary btn-block btn-lg btn-lg-reset-font-size text-uppercase text-letter-spacing2 white-space-normal">Absenden</button>
                </div>
            </div>
            <div id="errorbox" class="errorBox" style="display:none">
                <p>Bitte berichtige die markierten Felder</p>
            </div>
        </div>
        <div id="goodbye" style="display:none">
            <div>Das Passwort wurde geändert, du kannst dich jetzt anmelden</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'changePassword',
    props: {
        'hash': {
            type: String,
            required: false,
            default: null
        }
    },
    data: function() {
        return {
            oldPassword: null,
            newPassword1: null,
            newPassword2: null,
            captcha: null,
        }
    },
    created: function() {
        //this.fetchData(this.articleId, this.offset, this.length);
    },
    methods: {
        changePassword() {
            jQuery.ajax({
                url: '/changePassword.json',
                type: 'POST',
                dataType: "json",
                data: JSON.stringify({
                    oldPassword: this.oldPassword,
                    newPassword1: this.newPassword1,
                    newPassword2: this.newPassword2,
                    captcha: this.captcha,
                    hash: this.hash
                }),
                contentType: "application/json; charset=utf-8",
                success: function(data) {
                    console.debug("Success - " + JSON.stringify(data));
                    jQuery("#enterdata").hide();
                    jQuery("#goodbye").show();
                },
                error: function(error) {
                    console.debug("Error - " + JSON.stringify(error));
                    jQuery('#errorbox').empty();
                    let errorCodes = error.responseJSON.whathappend;
                    for (let i = 0; i < errorCodes.length; i++) {
                        jQuery('#errorbox').append('<p>' + errorCodes[i][0] + '</p>');
                    }
                    jQuery("#errorbox").show();
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// ChangePassword.vue?70f0b443